module.exports = __webpack_public_path__ + "assets/img/0604.551bf484.png";